import React from 'react';
import { Spinner } from 'reactstrap';
import './Loading.css'

const Example = () => {
    return (
        <div className="loading">
            <div className="centered">
                <Spinner color="success" />
            </div>
        </div>
    );
}

export default Example;